/* global window */
export default {
  initializeClear: () => {
    // Clear the ADS cache.
    window.meso = window.meso || {};
    window.meso.initialize = window.meso.initialize || [];
    window.meso.initialize.push({ type: 'clear' });
  }
};
